module.exports = "<div>\n  <h3 class=\"text-center\">Currently there are no candidacies to approve/deny</h3>\n</div>"